let completePendingTransition: null | (() => void) = null;

export const beginViewTransitionNavigation = (timeoutMs = 400) =>
  new Promise<void>((resolve) => {
    completePendingTransition?.();

    const timeoutId = window.setTimeout(() => {
      completePendingTransition = null;
      resolve();
    }, timeoutMs);

    completePendingTransition = () => {
      window.clearTimeout(timeoutId);
      completePendingTransition = null;
      resolve();
    };
  });

export const finishViewTransitionNavigation = () => {
  completePendingTransition?.();
};
